











































































































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import ImageSize from "@/components/ImageSize.vue";

export default Vue.extend({
  name: "NotifyList",
  components: {
    ImageSize
  },
  data() {
    return {
      perPage: 10,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      randomPrizeDoing: false,
      file: null,
      upLoading: false
    };
  },
  computed: {
    ...mapGetters({
      listNotify: "notify/items",
      loading: "notify/loading",
      count: "notify/count"
    })
  },
  methods: {
    ...mapActions({
      deleteNotify: "notify/deleteItem",
      changePage: "notify/changePage",
      perPageChangedAct: "notify/perPageChanged"
    }),
    ...mapMutations({
      setSelected: "notify/setSelected",
      setItemModal: "notify/setItemModal",
      setSendModal: "notify/setSendModal"
    }),
    deleteProductCampaign(id: string) {
      this.deleteNotify({
        idItem: id,
        textMess: "thông báo"
      });
    },
    onPageChange(e) {
      this.changePage(e);
    },
    perPageChanged() {
      this.perPageChangedAct(this.perPage);
    },
    handleOpenModalEdit(payload) {
      this.setItemModal({ ...payload, show: true });
    },
    handleOpenModalSend(payload) {
      this.setSendModal({ show: true, ...payload });
    },
    checked(e) {
      this.setSelected(e);
    }
  }
});
